<template>
  <div class="Banner">
    <swiper :options="swiperOption" ref="mySwiper">
      <swiper-slide>
        <img class="banner_img" src="../../assets/image/SdgsReports/1.png" alt="image" />
        <div class="swiper_content">
          <div class="swiper_content_box">
            <div class="content_tit">
              <div class="content_txt">Big Earth Data for SDGs</div>
            </div>
            <div
              class="content_text ani"
              swiper-animate-effect="fadeInRight"
              swiper-animate-duration=".5s"
              swiper-animate-delay="0.5s"
            >Digital connections, shared prosperity, for our people, for our planet.</div>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <img class="banner_img" src="../../assets/image/SdgsReports/1.png" alt="image" />
        <div class="swiper_content">
          <div class="swiper_content_box">
            <div class="content_tit">
              <div class="content_txt">Big Earth Data for SDGs</div>
            </div>
            <div
              class="content_text ani"
              swiper-animate-effect="fadeInRight"
              swiper-animate-duration=".5s"
              swiper-animate-delay="0.5s"
            >Big earth data-driven innovations towards the Sustainable Development Goals, for a better world.</div>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <img class="banner_img" src="../../assets/image/SdgsReports/1.png" alt="image" />
        <div class="swiper_content">
          <div class="swiper_content_box">
            <div class="content_tit">
              <div class="content_txt">Big Earth Data for SDGs</div>
            </div>
            <div
              class="content_text ani"
              swiper-animate-effect="fadeInRight"
              swiper-animate-duration=".5s"
              swiper-animate-delay="0.5s"
            >Big earth data-driven innovations towards the Sustainable Development Goals, for a better world.</div>
          </div>
        </div>
      </swiper-slide>
    </swiper>
    <div class="pagination_boxs">
      <div class="swiper-paginations"></div>
    </div>
  </div>
</template>

<script>
// 引入插件
import { swiper, swiperSlide, Pagination } from "vue-awesome-swiper";
import {
  swiperAnimateCache,
  swiperAnimate
} from "@/assets/js/swiper.animate1.0.3.min.js";
import "swiper/dist/css/swiper.css";
export default {
  name: "Home",
  components: {
    swiper,
    swiperSlide,
    Pagination
  },
  data() {
    return {
      swiperOption: {
        loop: true,
        slidesPerView: 3.5,
        centeredSlides: true,
        autoplay: {
          delay: 900000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        // 显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true //允许分页点击跳转
        },
        // 设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        on: {
          init: function() {
            swiperAnimateCache(this);
            swiperAnimate(this);
          },
          slideChangeTransitionStart: function() {},
          slideChangeTransitionEnd: function() {},
          slideChange: function() {
            swiperAnimate(this);
          }
        }
      }
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  mounted() {}
};
</script>

<style lang="scss" scoped >
.slide-fade-enter-active {
  transition: all 0.8s ease;
}
.slide-fade-leave-active {
  transition: all 0s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(100px);
  opacity: 0;
}
.swiper_content {
  position: absolute;
  top: 0px;
  padding-bottom: 120px;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.1);
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  .swiper_content_box {
    // height: 100%;
    width: 1200px;
    margin: 0 auto;
    .content_tit {
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;

      width: 680px;
      background-image: -webkit-linear-gradient(right, #2e42ad, #27c5f4);
      font-family: Arial, Helvetica, sans-serif;

      .content_txt {
        background: hsla(0, 0%, 100%, 0.1);
        padding: 10px;
        border-radius: 5px;
        font-size: 54px;
        font-weight: 600;
      }
      // display: block;
      // height: 46px;
      // font-size: 50px;
      // img {
      //   height: 46px;
      // }
    }
    .content_text {
      margin-top: 40px;
      // width: 606px;
      display: inline-block;
      // height: 70px;
      width: 600px;
      background: rgba(216, 216, 216, 0.13);
      font-size: 24px;
      font-weight: 400;
      // line-height: 50px;
      padding: 20px;
      // opacity: .13;
    }
  }
}
// .pagination_boxs {
//   width: 1200px;
//   margin: auto;
//   .swiper-paginations {

//   width: 1200px !important;
//   justify-content: flex-start;
//   display: flex;
//   flex-direction: row;
// }
// .swiper-pagination-bullet-active {
//   width: 30px !important;
//   height: 12px;
//   border-radius: 0;
//   transition: 0.2s;
//   background: #056cee !important;
// }

// .swiper-pagination-bullet {
//   width: 12px;
//   height: 12px;
//   border-radius: 0;
//   margin-right: 6px;
//   transition: 0.2s;
//   background: #fff;
//   opacity: 1;
// }
// }

.swiper {
  --swiper-theme-color: #ff6600; /* 设置Swiper风格 */
  --swiper-navigation-color: #00ff33; /* 单独设置按钮颜色 */
  --swiper-navigation-size: 30px; /* 设置按钮大小 */
}
.Banner {
  width: 100%;
  position: relative;
  overflow: hidden;
  height: 220px;
  .swiper-container {
    width: 100%;
    height: 100%;
  }
  .banner_img {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }
}
</style>